/**
 * Language storage utility for persisting user's language preference
 */

const LANGUAGE_KEY = 'scam-checker-language';

export const languageStorage = {
  /**
   * Get stored language preference
   */
  get(): string | null {
    return localStorage.getItem(LANGUAGE_KEY);
  },

  /**
   * Store language preference
   */
  set(language: string): void {
    localStorage.setItem(LANGUAGE_KEY, language);
  },

  /**
   * Remove stored language preference
   */
  remove(): void {
    localStorage.removeItem(LANGUAGE_KEY);
  },
};
